import { breakpoints, colors } from '@web-for-marketing/react-ui';

export const blogCard1Styles = {
    cardContainer: {
        width: '100%',
        outline: 'none',
        '&:focus-within': {
            outline: `1px solid ${colors.border.activePrimary}`,
            outlineOffset: '3px',
            borderRadius: '0.8rem',
        },
        '&:hover img': {
            transform: 'scale(1.05)',
        },
    },
    picture: {
        width: '100%',
        borderRadius: '0.8rem',
        overflow: 'hidden',
        height: '24rem',
        [`@media (max-width: ${breakpoints.sm})`]: {
            height: '21rem',
        },
    },
    categoryMargins: {
        margin: '16px 0 8px 0',
        [`@media (max-width: ${breakpoints.sm})`]: {
            margin: '12px 0 8px 0',
        },
    },
    title: (hasCategoryPill: boolean) => ({
        marginTop: hasCategoryPill ? 0 : '1.6rem',
        marginBottom: '0.8rem',
        '&:hover': {
            color: colors.text.activePrimary,
        },
    }),
    textTruncate: {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    textTruncateDescription: {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 3,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    hideOnMobile: {
        [`@media (max-width: ${breakpoints.sm})`]: {
            display: 'none',
        },
    },
} as const;
